/* ==========================================================================
   HIKARU CARDS HEADER MOBILE MENU FUNCTIONALITY
   ========================================================================== */

(function() {
  'use strict';

  let isMenuOpen = false;
  let menuDrawer = null;
  let overlay = null;
  let closeButton = null;

  function initMobileMenu() {
    const menuButton = document.querySelector('.hikaru-mobile-menu-btn');
    
    if (!menuButton) {
      return;
    }

    // Create menu drawer
    createMenuDrawer();
    
    // Add event listeners
    menuButton.addEventListener('click', toggleMenu);
  }

  function createMenuDrawer() {
    // Create overlay
    overlay = document.createElement('div');
    overlay.className = 'hikaru-mobile-menu-overlay';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.addEventListener('click', closeMenu);

    // Create menu drawer container
    menuDrawer = document.createElement('div');
    menuDrawer.className = 'hikaru-mobile-menu-drawer';
    menuDrawer.setAttribute('aria-hidden', 'true');
    menuDrawer.setAttribute('role', 'dialog');
    menuDrawer.setAttribute('aria-modal', 'true');
    menuDrawer.setAttribute('aria-label', 'Mobile navigation menu');

    // Create close button
    closeButton = document.createElement('button');
    closeButton.className = 'hikaru-mobile-menu-close';
    closeButton.setAttribute('aria-label', 'Close mobile menu');
    closeButton.innerHTML = `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;
    closeButton.addEventListener('click', closeMenu);

    // Create menu content
    const menuContent = document.createElement('div');
    menuContent.className = 'hikaru-mobile-menu-content';
    
    // Get navigation menu from desktop version or create fallback
    const desktopNav = document.querySelector('.hikaru-nav__menu');
    if (desktopNav) {
      // Convert desktop menu to mobile format
      const mobileMenu = document.createElement('ul');
      mobileMenu.className = 'hikaru-mobile-nav__menu';
      
      // Get all desktop menu items
      const desktopItems = desktopNav.querySelectorAll('.hikaru-nav__item');
      desktopItems.forEach(item => {
        const link = item.querySelector('.hikaru-nav__link');
        if (link) {
          const mobileItem = document.createElement('li');
          mobileItem.className = 'hikaru-mobile-nav__item';
          
          const mobileLink = document.createElement('a');
          mobileLink.className = 'hikaru-mobile-nav__link';
          mobileLink.href = link.href;
          
          // Get the icon from desktop menu
          const iconContainer = link.querySelector('.hikaru-nav__icon');
          if (iconContainer) {
            const icon = iconContainer.querySelector('img');
            if (icon) {
              // Create icon element for mobile
              const mobileIcon = document.createElement('div');
              mobileIcon.className = 'hikaru-mobile-nav__icon';
              mobileIcon.innerHTML = `<img src="${icon.src}" alt="${icon.alt}" width="40" height="40">`;
              mobileLink.appendChild(mobileIcon);
            }
          }
          
          // Add text - always show text in mobile, even for Preventas
          const textElement = document.createElement('span');
          textElement.className = 'hikaru-mobile-nav__text';
          
          // Get text from desktop menu, but always show it in mobile
          const desktopText = link.querySelector('.hikaru-nav__text')?.textContent;
          const linkText = link.textContent.trim();
          
          // For Preventas, use the link text since desktop doesn't show text
          if (linkText.includes('Preventas') || desktopText === '') {
            textElement.textContent = 'Preventas';
          } else {
            textElement.textContent = desktopText || linkText;
          }
          
          mobileLink.appendChild(textElement);
          
          mobileItem.appendChild(mobileLink);
          mobileMenu.appendChild(mobileItem);
        }
      });
      
      menuContent.appendChild(mobileMenu);
    } else {
      // Fallback menu content
      menuContent.innerHTML = `
        <ul class="hikaru-mobile-nav__menu">
          <li class="hikaru-mobile-nav__item">
            <a href="/collections/pokemon" class="hikaru-mobile-nav__link">
              <div class="hikaru-mobile-nav__icon">⚡</div>
              <span class="hikaru-mobile-nav__text">Pokémon</span>
            </a>
          </li>
          <li class="hikaru-mobile-nav__item">
            <a href="/collections/pokemon-jp" class="hikaru-mobile-nav__link">
              <div class="hikaru-mobile-nav__icon">🇯🇵</div>
              <span class="hikaru-mobile-nav__text">Pokémon JP</span>
            </a>
          </li>
          <li class="hikaru-mobile-nav__item">
            <a href="/collections/singles-slabs" class="hikaru-mobile-nav__link">
              <div class="hikaru-mobile-nav__icon">💎</div>
              <span class="hikaru-mobile-nav__text">Singles & Slabs</span>
            </a>
          </li>
          <li class="hikaru-mobile-nav__item">
            <a href="/collections/otros" class="hikaru-mobile-nav__link">
              <div class="hikaru-mobile-nav__icon">🎴</div>
              <span class="hikaru-mobile-nav__text">Otros</span>
            </a>
          </li>
          <li class="hikaru-mobile-nav__item">
            <a href="/pages/info" class="hikaru-mobile-nav__link">
              <div class="hikaru-mobile-nav__icon">ℹ️</div>
              <span class="hikaru-mobile-nav__text">Info</span>
            </a>
          </li>
          <li class="hikaru-mobile-nav__item">
            <a href="/collections/preventas" class="hikaru-mobile-nav__link">
              <div class="hikaru-mobile-nav__icon">🚀</div>
              <span class="hikaru-mobile-nav__text">Preventas</span>
            </a>
          </li>
        </ul>
      `;
    }

    // Assemble the drawer
    menuDrawer.appendChild(closeButton);
    menuDrawer.appendChild(menuContent);
    
    // Add to body
    document.body.appendChild(overlay);
    document.body.appendChild(menuDrawer);
  }

  function toggleMenu() {
    if (isMenuOpen) {
      closeMenu();
    } else {
      openMenu();
    }
  }

  function openMenu() {
    isMenuOpen = true;
    
    // Update ARIA attributes
    const menuButton = document.querySelector('.hikaru-mobile-menu-btn');
    if (menuButton) {
      menuButton.setAttribute('aria-expanded', 'true');
    }
    
    if (menuDrawer) {
      menuDrawer.setAttribute('aria-hidden', 'false');
    }
    
    if (overlay) {
      overlay.setAttribute('aria-hidden', 'false');
    }
    
    // Add classes for animation
    if (menuDrawer) {
      menuDrawer.classList.add('open');
    }
    
    if (overlay) {
      overlay.classList.add('open');
    }
    
    document.body.classList.add('hikaru-menu-open');
    
    // Focus management
    if (closeButton) {
      closeButton.focus();
    }
    
    // Prevent body scroll
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    isMenuOpen = false;
    
    // Update ARIA attributes
    const menuButton = document.querySelector('.hikaru-mobile-menu-btn');
    if (menuButton) {
      menuButton.setAttribute('aria-expanded', 'false');
    }
    
    if (menuDrawer) {
      menuDrawer.setAttribute('aria-hidden', 'true');
    }
    
    if (overlay) {
      overlay.setAttribute('aria-hidden', 'true');
    }
    
    // Remove classes
    if (menuDrawer) {
      menuDrawer.classList.remove('open');
    }
    
    if (overlay) {
      overlay.classList.remove('open');
    }
    
    document.body.classList.remove('hikaru-menu-open');
    
    // Return focus to menu button
    if (menuButton) {
      menuButton.focus();
    }
    
    // Restore body scroll
    document.body.style.overflow = '';
  }

  function handleKeydown(event) {
    if (event.key === 'Escape' && isMenuOpen) {
      closeMenu();
    }
  }

  function handleResize() {
    // Close menu if resizing to desktop
    if (window.innerWidth > 1200 && isMenuOpen) {
      closeMenu();
    }
  }

  function initSearchModalFocus() {
    const searchModal = document.querySelector('.hikaru-search-modal');
    
    if (!searchModal) {
      return;
    }

    const detailsElement = searchModal.querySelector('details');
    
    if (!detailsElement) {
      return;
    }

    // Add toggle event listener to the details element
    detailsElement.addEventListener('toggle', function(event) {
      // Check if the modal is now open
      if (event.target.open === true) {
        // Find the search input - try ID first, then fallback to type selector
        const searchInput = document.getElementById('Search-In-HikaruModal') || 
                           detailsElement.querySelector('input[type="search"]');
        
        if (searchInput) {
          // Use setTimeout to ensure the modal is fully rendered before focusing
          setTimeout(function() {
            searchInput.focus();
          }, 100);
        }
      }
    });
  }

  // Initialize when DOM is ready
  function init() {
    // Wait a bit for the header to be rendered
    setTimeout(() => {
      initMobileMenu();
      initSearchModalFocus();
    }, 100);
    
    // Add global event listeners
    document.addEventListener('keydown', handleKeydown);
    window.addEventListener('resize', handleResize);
  }

  // Start when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();